/* eslint-disable react/no-array-index-key */

import React from 'react';

import Cta from 'core/components/Cta';
import { ICONS } from 'core/components/Icon/Icon';
import * as Typo from 'core/styles/Typography';
import { useModal } from 'core/hooks';

import * as S from './HelpLinkModal.style';

interface IHelpLinkModal {
	/** Text of the CTA button */
	text: string;
	/** Title of the Modal Dialog */
	modalTitle?: string;
	/** Content of the Modal Dialog */
	modalContent: string;
	/** Label for Modal Dialog close button */
	modalCloseButtonText?: string;
	/** Click event. Useful for adding extra logic to the default behavior */
	onClick?: () => void;
}

const HelpLinkModal = ({
	text,
	modalTitle,
	modalContent,
	modalCloseButtonText,
	onClick,
}: IHelpLinkModal) => {
	const [Modal, toggleModal] = useModal();

	return (
		<>
			<S.Wrapper>
				<Cta
					size="medium"
					ctaStyle="plain"
					iconAlign="left"
					ctaType="button"
					icon={ICONS.HELP_OUTLINE}
					onClick={() => {
						onClick?.();
						toggleModal();
					}}
				>
					{text}
				</Cta>
			</S.Wrapper>
			<Modal>
				{modalTitle && <Typo.DisplayMedium>{modalTitle}</Typo.DisplayMedium>}
				<Typo.Body isRichText margin="18px 0 30px">
					{modalContent}
				</Typo.Body>
				<S.CloseButton>
					<Cta
						ctaStyle="primary"
						ctaType="button"
						onClick={() => toggleModal()}
					>
						{modalCloseButtonText ?? 'Close'}
					</Cta>
				</S.CloseButton>
			</Modal>
		</>
	);
};

export default HelpLinkModal;
